import React, { useEffect, useState } from "react";
import AnalyticsGraph from "./AnalyticsGraph.jsx";
import { ax_analytics_fetchAnalytics } from "../api/analytics.js";
// import { ArrChevronRightO } from "lovedicons/dist/arrO";
import MenuIcon from "./MenuIcon.jsx";

const AnalyticsDashboard = ({
  showSidebar,
  setShowSidebar,
  setCreatedFromBrand,
  togglePopupShow,
  handleShowAddUser,
}) => {
  const [analyticsData, setAnalyticsData] = useState({
    approved: 0,
    pending: 0,
    rejected: 0,
    total: 0,
    null: 0,
  });

  const analyticsContent = [
    {
      name: "Total Request",
      title: "Total",
      value: analyticsData?.total,
    },
    {
      name: "Total Approved",
      title: "Approved",
      value: analyticsData?.approved,
    },
    {
      name: "Total Pending",
      title: "Pending",
      value: analyticsData?.pending,
    },
    {
      name: "Total Rejected",
      title: "Rejected",
      value: analyticsData?.rejected,
    },
  ];

  //   {
  //     "code": 200,
  //     "success": true,
  //     "description": "Analytics fetched successfully",
  //     "data": {
  //         "Approved": 1,
  //         "Pending": 1,
  //         "Rejected": 0,
  //         "null": 0,
  //         "total": 2,
  //         "perBrand": {
  //             "bsa": {
  //                 "Approved": 1,
  //                 "Pending": 0,
  //                 "Rejected": 0
  //             },
  //             "machcity": {
  //                 "Approved": 0,
  //                 "Pending": 0,
  //                 "Rejected": 0
  //             },
  //             "hercules": {
  //                 "Approved": 0,
  //                 "Pending": 0,
  //                 "Rejected": 0
  //             },
  //             "herculesFitness": {
  //                 "Approved": 0,
  //                 "Pending": 0,
  //                 "Rejected": 0
  //             },
  //             "trackAndTrail": {
  //                 "Approved": 0,
  //                 "Pending": 1,
  //                 "Rejected": 0
  //             },
  //             "montra": {
  //                 "Approved": 0,
  //                 "Pending": 0,
  //                 "Rejected": 0
  //             }
  //         }
  //     }
  // }

  const fetchAnalyticsData = async () => {
    const res = await ax_analytics_fetchAnalytics();
    // const { data } = await ax_analytics_fetchAnalytics();
    // const { code, success, data, description } =
    //   await ax_analytics_fetchAnalytics();
    if (res?.data) {
      setAnalyticsData({
        approved: res?.data?.Approved,
        pending: res?.data?.Pending,
        rejected: res?.data?.Rejected,
        total: res?.data?.total,
        null: res?.data?.null,
      });
      // console.log("if pass");
    }
    // else {
    //   console.log("else pass");
    // }
    // console.log("fetchAnalyticsData");
    // console.log("fetchAnalyticsData", JSON.stringify(res?.data));
    // const { code, success, description, data } =
    //   await ax_analytics_fetchAnalytics();

    // console.log(
    //   "ax_res_analytics - ",
    //   JSON.stringify(code + success, description, data)
    // );
    // console.log("ax_res_analytics - ", code, success, data, description);
  };

  useEffect(() => {
    fetchAnalyticsData();
  }, []);

  // console.log("analyticsData - ", analyticsData);

  return (
    <main className="h-full w-full">
      <section className="px-0 xl:pl-4 h-full w-full">
        <div className="flex justify-between items-center p-2 bg-white rounded-md shadow-sm">
          <div className="flex items-center justify-center">
            <MenuIcon
              showSidebar={showSidebar}
              setShowSidebar={setShowSidebar}
              setCreatedFromBrand={setCreatedFromBrand}
              togglePopupShow={togglePopupShow}
              handleShowAddUser={handleShowAddUser}
            />
            <div className="ml-1 sm:ml-2 text-lg font-semibold">Analytics</div>
          </div>
          {/* <input
            type="date"
            className="border rounded-lg p-2 md:py-2 md:px-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          /> */}
          {/* <input
            type="date"
            className="border rounded-lg p-2 md:py-2 md:px-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
          /> */}
        </div>
      </section>
      <section className="w-full h-full py-4 xl:p-4 xl:pr-0 gap-4 md:gap-6 grid grid-cols-1 md:grid-cols-2">
        <div className="flex-grow w-full h-full">
          <AnalyticsGraph />
        </div>
        <section className="w-full flex-grow grid grid-cols-2 gap-4 md:gap-6">
          {analyticsContent?.map((_analytics, index) => (
            <div
              className="w-full flex flex-col flex-grow bg-gray-50 p-3 lg:p-6 rounded-lg shadow"
              key={index}
            >
              <div className="text-sm lg:text-xl font-semibold">
                {_analytics?.name}
              </div>
              <div className="py-2 flex flex-grow items-center justify-center text-3xl lg:text-5xl font-bold text-gray-400 text-center">
                {_analytics?.value}
                {/* <p className="text-gray-500 text-right mt-2">Today</p> */}
              </div>
              <div className="flex justify-between items-center ">
                <div className="text-xs lg:text-sm">
                  View {_analytics?.title}
                </div>

                {/* <div>
                  <ArrChevronRightO className="w-5 h-5" />
                </div> */}
              </div>
            </div>
          ))}
        </section>
      </section>
    </main>
  );
};

export default AnalyticsDashboard;
